export default {
  // namespaced: true,
  state: {
    modalos: [
      // {id: 123, alert: false}
    ]
  },
  mutations: {
    SET_MODALO (store, id) {
      store.modalos.push({ id: id, alert: false })
    },
    REMOVE_MODALO (store, id) {
      const index = store.modalos.findIndex(v => v.id === id)
      if (index >= 0) {
        store.modalos.splice(index, 1)
      }
    },
    CHANGE_LAST_MODALO (store, alert = true) {
      const index = store.modalos.length - 1
      if (index >= 0) {
        store.modalos[index].alert = alert
      }
    }
  },
  getters: {
    getModalo: (store, getters) => {
      return store.modalos
    }
  },
  actions: {
    /*
    setModalo
    */
    setModalo ({commit, dispatch, getters, state}, id) {
      commit('SET_MODALO', id)
      return id
    },
    /*
    removeModalo
    */
    removeModalo ({commit, dispatch, getters, state}, id) {
      commit('REMOVE_MODALO', id)
      return id
    },
    /*
    changeModalo
    */
    changeLastModalo ({commit, dispatch, getters, state}) {
      commit('CHANGE_LAST_MODALO', true)
      return null
    },
    /*
    resetLastModalo
    */
    resetLastModalo ({commit, dispatch, getters, state}) {
      commit('CHANGE_LAST_MODALO', false)
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Modalo.js